// authProvider.js
import React from 'react';
import * as graphql from './graphql';
import { firebaseApp } from './firebase';
import gql from 'graphql-tag';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ErrorContextConsumer } from '../common/error';

export const ROLE_ADMIN = "ADMIN";
export const ROLE_OWNER = "OWNER";
export const ROLE_EDITOR = "EDITOR";
export const ROLE_READER = "READER";
export const ROLE_ASSISTANT = "ASSISTANT";

export function isInRoles(userRoles, roles) {

    if (roles === null || userRoles === null) {
        return false;
    }

    let contains = false;

    for (const userRole of userRoles) {
        contains = contains || roles.includes(userRole)
    }

    return contains;
}


export function withIAM(WrappedComponent) {
    return class extends React.Component {

        constructor(props) {
            super(props);

            this.state = {
                user: null,
                roles: null,
                intitializing: true,
                token: null
            };
        }

        componentDidMount() {
            firebaseApp.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebaseApp.auth().currentUser.getIdToken().then(token => {
                        this.setState({ user: user, token: token, intitializing: false })
                    });
                } else {
                    this.setState({ user: null, intitializing: false, token: null })
                }
            });

        }

        handleLogout = () => {

            firebaseApp.auth().signOut().then(() => {
                this.setState({ user: null, groups: null, intitializing: false });
            });

        };

        render() {

            return <ErrorContextConsumer>
            {({ handleError }) => {
                if (this.state.intitializing) {
                    return <div style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <CircularProgress />
                    </div>
                }
    
    
                const isAuth = this.state.user && this.state.token;
    
                if (!isAuth) {
                    window.location = "/login";
                    return null;
                } else if (!this.state.roles) {
                    graphql.clientWithToken(this.state.token).query({
                        query: gql`
                        query {
                            currentUser {
                              roles
                            }
                        }
                    `,
                        fetchPolicy: "no-cache"
                    }).then((result) => {
                        this.setState({
                            roles: result.data.currentUser.roles
                        })
                    }).catch((error) => {
                        handleError(error);
                    })
    
                    return <div style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <CircularProgress />
                    </div>
                } else {
    
                    return <WrappedComponent
                        onLogout={this.handleLogout}
                        user={this.state.user}
                        accessToken={this.state.token}
                        roles={this.state.roles} {...this.props} />
                }
                
            }}
            </ErrorContextConsumer>

        }

    };
}

